import Vue from 'vue'

export default [
  {
    path: '/management_control',
    name: 'ManagementControl',
    beforeEnter: (to, from, next) => {
      let isAuthorizationAccountOrEip
      try {
        isAuthorizationAccountOrEip = JSON.parse(localStorage.getItem('loginUserInfo')).IsAuthorizationAccount || JSON.parse(localStorage.getItem('loginUserInfo')).IsFromEip
      } catch (error) {
        isAuthorizationAccountOrEip = false
      }
      if (isAuthorizationAccountOrEip) {
        next()
      } else {
        Vue.prototype.$alert('您無權限操作此功能，請使用手機帳號重新登入', '警告', {
          confirmButtonText: '確定',
          type: 'warning',
          showClose: false,
          roundButton: true,
          closeOnClickModal: false
        })
      }
    },
    component: () => import('@/views/ManagementControl/ManagementControl.vue'),
    meta: {
      prev: 'goHome',
      header: 'management'
    }
  }
]
